<template>
	<el-dialog
		:title="editForm.id==null||editForm==''? pileType == 'Q' ? '登记汽车桩费率':'登记电单车桩费率':pileType == 'Q'?'编辑汽车桩费率':'编辑电单车桩费率'"
		:visible="editFormVisible" :close-on-click-modal="false"
		:close-on-press-escape="editForm.id!=null&&editForm!=''" :modal-append-to-body='false'
		:before-close="clearEditForm">
		<el-form :model="editForm" ref="editForm" size="mini" class="edit_form" :rules="editFormRules">
			<el-row>
				<el-col :span="10">
					<el-form-item label="费率名称" :label-width="formLabelWidth" class="required" prop="ruleName">
						<el-input size="mini" autocomplete="off" placeholder="请填写" v-model="editForm.ruleName">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="10">
          <el-form-item label="运营商：" :label-width="formLabelWidth" prop="operatorId">
            <el-select  v-model="editForm.operatorId" >
              <el-option v-for="item in operatorForSelect"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
				</el-col>

			</el-row>

			<el-row style="text-align: left;">
				价格类别
			</el-row>
			<el-row style=" display:flex; align-items: center; justify-content: center;margin-top: 20px;" :gutter="20" v-for="(item,index) in kindList" :key="item.name">
				<el-col :span="1">
					<span>{{ item.name }}</span>
				</el-col>
				<el-col :span="7">
				<el-input  v-model="item.electric" @blur="inputBlur" type="text" onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/);this.dispatchEvent(new Event('input'))">
					<template slot="prepend">电费</template>
					<template slot="append">元/度</template>
				</el-input>
			</el-col>
				<el-col :span="8">
				<el-input v-model="item.serve" @blur="inputBlur" type="text" onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/);this.dispatchEvent(new Event('input'))">
					<template slot="prepend">原价服务费</template>
					<template slot="append">元/度</template>
				</el-input>
			</el-col>
			<el-col :span="8">
				<el-input v-model="item.serveVip" @blur="inputBlur" type="text" onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/);this.dispatchEvent(new Event('input'))">
					<template slot="prepend">会员服务费</template>
					<template slot="append">元/度</template>
				</el-input>
			</el-col>
			</el-row>

			<el-row style="text-align: left;">
				价格设置
			</el-row>
			<el-row v-for="(item,index) in timeSlotList" :key="index" :gutter="10"  style=" display:flex; align-items: center; justify-content: center;margin-top: 20px;">
				<el-col :span="6">
				<el-time-select style="width: 160px;"
					placeholder="起始时间"
					v-model="item.beginTime"
					:picker-options="{
					start: '00:00',
					step: '00:30',
					end: '24:00',
					}">
				</el-time-select>
			</el-col>
			<el-col :span="1">至</el-col>
			<el-col :span="6">
				<el-time-select
				style="width: 160px;"
					placeholder="结束时间"
					v-model="item.endTime"
					:picker-options="{
					start: '00:00',
					step: '00:30',
					end: '24:00',
					}">
				</el-time-select>
			</el-col>
			<el-col :span="7">
				<el-select v-model="item.code">
					<el-option
					v-for="item in kindList"
					:key="item.id"
					:label="item.allName"
					:value="item.id">
					</el-option>
				</el-select>
			</el-col>
			<el-button size="mini" type="danger" @click="del(index)">删除</el-button>
			</el-row>
			<el-row style="display: flex; align-items: left; margin-top: 20px;">
			<el-button type="primary" @click="add">新增</el-button>
			</el-row>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="small" @click="clearEditForm">取 消</el-button>
			<el-button size="small" type="primary" @click.native="editSubmit" :loading="editSubmitLoading">确 定
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
import {
  validateInput,
  verifyDiscountRate,
} from "../../../../common/validator";
import rateApi from "../../../resourceCenter/api/rateApi";
import commonApi from "../../api/commonApi";
export default {
  name: "add",
  data() {
    return {
      editFormRules: {
        ruleName: [
          {
            required: true,
            message: "请输入费率名称",
            trigger: "blur",
          },
          {
            validator: function (rule, value, callback) {
              validateInput(
                rule,
                value,
                callback,
                0,
                12,
                true,
                true,
                false,
                false,
                false,
                false,
                false
              );
            },
            trigger: "blur",
          },
        ],
        operatorId: [
          {
            required: true,
            message: "请选择运营商",
            trigger: "blur",
          },
        ],
        appointmentPrice: [
          {
            validator: function (rule, value, callback) {
              validateInput(
                rule,
                value,
                callback,
                0,
                12,
                true,
                false,
                false,
                false,
                false,
                false,
                true
              );
            },
            trigger: "blur",
          },
        ],
        appointmentTimes: [
          {
            validator: function (rule, value, callback) {
              validateInput(
                rule,
                value,
                callback,
                0,
                12,
                true,
                true,
                true,
                true,
                false,
                false,
                false
              );
            },
            trigger: "blur",
          },
        ],
        discountRate: [
          {
            required: true,
            message: "请输入折扣率",
            trigger: "blur",
          },
          {
            validator: verifyDiscountRate,
            trigger: "blur",
          },
        ],
        electricLossRate: [
          {
            required: true,
            message: "请输入电损率",
            trigger: "blur",
          },
          {
            validator: verifyDiscountRate,
            trigger: "blur",
          },
        ],
        standardElectricityFees: [
          {
            validator: function (rule, value, callback) {
              validateInput(
                rule,
                value,
                callback,
                0,
                12,
                true,
                false,
                false,
                false,
                false,
                false,
                true
              );
            },
            trigger: "blur",
          },
        ],
        standardServiceFees: [
          {
            validator: function (rule, value, callback) {
              validateInput(
                rule,
                value,
                callback,
                0,
                12,
                true,
                false,
                false,
                false,
                false,
                false,
                true
              );
            },
            trigger: "blur",
          },
        ],
        vipLevel: [
          { required: false, message: "请选择VIP等级", trigger: "blur" },
        ],
        topElectricityFees: [
          {
            validator: function (rule, value, callback) {
              validateInput(
                rule,
                value,
                callback,
                0,
                12,
                true,
                false,
                false,
                false,
                false,
                false,
                true
              );
            },
            trigger: "blur",
          },
        ],
        summitElectricityFees: [
          {
            validator: function (rule, value, callback) {
              validateInput(
                rule,
                value,
                callback,
                0,
                12,
                true,
                false,
                false,
                false,
                false,
                false,
                true
              );
            },
            trigger: "blur",
          },
        ],
        flatElectricityFees: [
          {
            validator: function (rule, value, callback) {
              validateInput(
                rule,
                value,
                callback,
                0,
                12,
                true,
                false,
                false,
                false,
                false,
                false,
                true
              );
            },
            trigger: "blur",
          },
        ],
        valleyElectricityFees: [
          {
            validator: function (rule, value, callback) {
              validateInput(
                rule,
                value,
                callback,
                0,
                12,
                true,
                false,
                false,
                false,
                false,
                false,
                true
              );
            },
            trigger: "blur",
          },
        ],
        topServiceFees: [
          {
            validator: function (rule, value, callback) {
              validateInput(
                rule,
                value,
                callback,
                0,
                12,
                true,
                false,
                false,
                false,
                false,
                false,
                true
              );
            },
            trigger: "blur",
          },
        ],
        summitServiceFees: [
          {
            validator: function (rule, value, callback) {
              validateInput(
                rule,
                value,
                callback,
                0,
                12,
                true,
                false,
                false,
                false,
                false,
                false,
                true
              );
            },
            trigger: "blur",
          },
        ],
        flatServiceFees: [
          {
            validator: function (rule, value, callback) {
              validateInput(
                rule,
                value,
                callback,
                0,
                12,
                true,
                false,
                false,
                false,
                false,
                false,
                true
              );
            },
            trigger: "blur",
          },
        ],
        valleyServiceFees: [
          {
            validator: function (rule, value, callback) {
              validateInput(
                rule,
                value,
                callback,
                0,
                12,
                true,
                false,
                false,
                false,
                false,
                false,
                true
              );
            },
            trigger: "blur",
          },
        ],
      },
      formLabelWidth: "120px",
      operatorForSelect:[]
    };
  },
  props: {
    editForm: {},
    operatorId:'',
    editFormVisible: false,
    standardAble: false,
    editSubmitLoading: false,
    tableData: "",
    timesAble: "",
    topCheckFlag: "",
    summitCheckFlag: "",
    flatCheckFlag: "",
    valleyCheckFlag: "",
    YesNoEnumData: "",
    pileType: "",
    rulesId: "",
    kindList: {
      type: Array,
      required: true
    },
    timeSlotList: {
      type: Array,
      required: true
    },
    timeSlotId: "",
  },
  created: function () {
    this.operatorId = sessionStorage.getItem('operatorId')
    this.loadSelectItem();
  },

  watch: {
    '$store.state.operatorId': {
      handler: function (newVal, oldVal) {
        this.operatorId = sessionStorage.getItem('operatorId');
        this.loadSelectItem()
      },
      deep: true
    }
  },

  methods: {

    // 加载下拉框
    loadSelectItem() {
      // 运营商下拉框

      const param= {
        "id": this.operatorId
      }
      commonApi.getOperatorsTree(param).then((res) => {
        if (res.code === 0) {
          this.operatorForSelect = res.data
        }
      })

    },
    clearEditForm() {
      let _this = this;
      console.log(this.editForm.id);
      if (this.editForm.id == null || this.editForm == "") {
        this.$confirm("是否要取消当前操作？")
          .then((_) => {
            _this.$refs.editForm.clearValidate();
            _this.$emit("closeEditForm");
          })
          .catch((_) => {});
      } else {
        _this.$refs.editForm.clearValidate();
        _this.$emit("closeEditForm");
      }
    },
    editSubmit() {
      this.editForm.pileType = this.pileType;
     /* for (var i = 0; i < this.kindList.length; i++) {
        if (this.kindList[i].electric < 0) {
          this.$message.error("请输入正确的费率");
          return;
        } else if (this.kindList[i].serve < 0) {
          this.$message.error("请输入正确的费率");
          return;
        } else if (this.kindList[i].serveVip < 0) {
          this.$message.error("请输入正确的费率");
          return;
        } else if (!this.kindList[i].serve) {
          console.log(this.kindList[i].serve);
          this.$message.error("请输入正确的费率");
          return;
        } else if (!this.kindList[i].electric) {
          this.$message.error("请输入正确的费率");
          return;
        } else if (!this.kindList[i].serveVip) {
          this.$message.error("请输入正确的费率");
          return;
        }
      }*/
      let param = {
        flatElectricityFees: this.kindList[2].electric,
        flatServiceFees: this.kindList[2].serve,
        vipFlatServiceFees: this.kindList[2].serveVip,
        summitElectricityFees: this.kindList[1].electric,
        summitServiceFees: this.kindList[1].serve,
        vipSummitServiceFees: this.kindList[1].serveVip,
        topElectricityFees: this.kindList[0].electric,
        topServiceFees: this.kindList[0].serve,
        vipTopServiceFees: this.kindList[0].serveVip,
        valleyElectricityFees: this.kindList[3].electric,
        valleyServiceFees: this.kindList[3].serve,
        vipValleyServiceFees: this.kindList[3].serveVip,
        timeSlotList: this.timeSlotList,
        timeSlotId: this.timeSlotId,
        ruleName: this.editForm.ruleName,
        id: this.editForm.id,
        operatorId: this.editForm.operatorId,
      };
      rateApi.saveByPhone(param).then((res) => {
        if (res.code == 0) {
          this.$emit("editSubmit", this.$refs.editForm);
        } else {
          // this.$message.error(res.message)
        }
      });
    },
    timeMouseenter(event) {
      this.$emit("timeMouseenter", event);
    },
    timeMousedown(event) {
      this.$emit("timeMousedown", event);
    },
    topCheck() {
      this.$emit("topCheck");
    },
    summitCheck() {
      this.$emit("summitCheck");
    },
    flatCheck() {
      this.$emit("flatCheck");
    },
    valleyCheck() {
      this.$emit("valleyCheck");
    },
    standardInputChange() {
      this.$emit("standardInputChange");
    },
    timesInputChange() {
      this.$emit("timesInputChange");
    },
    inputBlur(e) {
      console.log(e);
      for (var i = 0; i < this.kindList.length; i++) {
        this.kindList[i].allName =
          this.kindList[i].name +
          ":电费" +
          this.kindList[i].electric +
          "," +
          this.kindList[i].name +
          ":原价服务费" +
          this.kindList[i].serve +
          ",会员服务费" +
          this.kindList[i].serveVip;
      }
    },
    del(index) {
      this.timeSlotList.splice(index, 1);
    },
    add() {
      this.timeSlotList.push({
        beginTime: "",
        endTime: "",
        code: "",
        name: "",
        type: "",
        showName: "",
        switchFlag: "",
        electricityFees: "",
        serviceFees: "",
        totalFees: "",
        underlineFees: "",
        vipServiceFees: "",
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .edit_form {
  .el-form-item__content {
    .el-input {
      width: 210px;
    }
  }
}

.timeLabOut {
  margin-top: 20px;
  user-select: none;
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}

.timeLabIn {
  user-select: none;
  width: 100%;
  line-height: 40px;
}

.timeLabInCol {
  user-select: none;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

.topCheck {
  background-color: rgba(245, 108, 108, 0.6);
}

.summitCheck {
  background-color: rgba(230, 162, 60, 0.6);
}

.flatCheck {
  background-color: rgba(103, 194, 58, 0.6);
}

.valleyCheck {
  background-color: rgba(64, 158, 255, 0.6);
}
/deep/ input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0; /* 重置按钮的默认外边距 */
}
/deep/ .el-input-group__prepend {
  font-size: 10px;
}
/deep/ .el-input-group__append {
  font-size: 10px;
}
/deep/ .el-input-group--append .el-input__inner {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/rateManager/add.vue